var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notas-examen-a-b-m',{attrs:{"headers":_vm.headers,"examen_id":_vm.examen_id,"only":_vm.only}})}
var staticRenderFns = []

export { render, staticRenderFns }